import React from "react";
import styles from "./index.module.scss";
import { Avatar } from "@mui/material";
import { Button } from "../../../common/components/Button";
import { DashedBorderBox } from "../../../common/components/DashedBorderBox";
import defaultProfileIcon from "../../../assets/images/default-profile.svg";
import cross_Bg from "../../../assets/images/cross-bg.svg";
import SessionOverlay from "../../../components/SeatApprovalFlow/SessionOverlay";
import { ApprovalStatus } from "../../../constants/textConstants";
import { SessionsGridProps } from "../../../types/seatApproval";
import uniarrow from "../../../assets/images/swap-arrow-1.svg";
import swaparrow from "../../../assets/images/swap-arrow-2.svg";
import profile from "../../../assets/images/profile-bg.webp";
import { handleSessionGridBlessAction } from "../../../utils/seekerApproval";

export const SessionsGrid: React.FC<SessionsGridProps> = ({
  sessions,
  dragOverSessionId,
  selectedSession,
  showOverlay,
  sessionId,
  approvedUsers,
  isLoading,
  programId,
  totalRecords,
  onDragOver,
  onDragLeave,
  onDrop,
  onSessionClick,
  onRemoveFromSession,
  onBless,
  onCloseOverlay,
  handleBlessed,
  selectedSwapSeeker,
  fetchApprovedUsersForSession,
  setShowOverlay,
  setExcludedUserId,
  setCustomTitle,
  setIsCardClicked,
  sessionpaginationProps,
  handleSessionPageChange,
  handleSessionPageSizeChange,
  setSessionSearchText,
  selectedFilter,
  setSelectedFilter,
  overlayLoader = false, // Default value for overlayLoader
}) => {
  console.log("SessionsGrid sessions:", sessions);

  const handleOpenSessionOverlay = async (
    userId: number,
    selectedSession?: unknown,
  ) => {
    // Use fetchApprovedUsersForSession to get all users with kpiCategory and kpiFilter as "all"
    console.log(selectedSession, "selectedSession");
    setShowOverlay(true); // Open the overlay
    setCustomTitle && setCustomTitle(`Select seeker to swap from ${selectedSession?.name}`);
    setIsCardClicked(true); // Set card clicked state to true
    setExcludedUserId(userId);

    fetchApprovedUsersForSession({
      kpiCategory: "allocated",
      kpiFilter: `program_${selectedSession.value || selectedSession.id}`,
      SwapRequests: selectedFilter?.wantsSwap || "",
    });
  };

  return (
    <div className={styles.sessionsGrid}>
      {sessions.map((session) => (
        <div
          key={session.id}
          className={`${styles.sessionCard} 
            ${dragOverSessionId === session.id ? styles.dragOver : ""}
            ${session.assignedUsers.length > 0 ? styles.hasUser : ""}`}
          onDragOver={(e) => onDragOver(e, session.id)}
          onDragLeave={onDragLeave}
          onDrop={(e) => onDrop(e, session.id)}
          onClick={() => onSessionClick(session)}
        >
          <div className={styles.sessionUsers}>
            {session.assignedUsers.length > 0 ? (
              session.assignedUsers.map((user) =>
                user.approvalStatus === ApprovalStatus?.PENDING ||
                  user.approvalStatus === ApprovalStatus?.ON_HOLD ||
                  user.approvalStatus === ApprovalStatus?.REJECTED ||
                  session.name == "Hold" ||
                  session.name == "YTD" ? (
                  <div
                    key={user.id}
                    className={styles.assignedUser}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <img
                      src={cross_Bg}
                      alt="cross"
                      className={styles.crossBg}
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveFromSession(user, session.id);
                      }}
                    />
                    <div className={styles.userInfo}>
                      <Avatar
                        alt="User Avatar"
                        src={user.profileImage || defaultProfileIcon}
                        sx={{
                          width: 60,
                          height: 60,
                          border: "1px solid #00000014",
                        }}
                        data-testid="user-avatar"
                      />
                      <span className={styles.fullnameStyles}>
                        {session.name !== "Hold"
                          ? session.name !== "YTD"
                            ? "bless"
                            : "YTD"
                          : "Hold"}{" "}
                        <div className={styles.fullnameEllipsis} title={user.fullName}>
                          {" "}
                          {user.fullName}
                        </div>
                        {session.name !== "Hold" && session.name !== "YTD"
                          ? `with ${session.name}`
                          : ""}
                      </span>
                    </div>

                    <div className={styles.buttonContainerbless}>
                      <Button
                        buttonClassName={styles.confirmButton}
                        buttonTextClassName={styles.cancelText}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleSessionGridBlessAction({
                            user,
                            session,
                            selectedSwapSeeker,
                            handleBlessed,
                            onBless,
                          });
                        }}
                      >
                        {session.name !== "Hold"
                          ? session.name !== "YTD"
                            ? "bless"
                            : "YTD"
                          : "Hold"}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div
                    key={user.id}
                    className={styles.assignedUser}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <img
                      src={cross_Bg}
                      alt="cross"
                      className={styles.crossBgnew}
                      onClick={(e) => {
                        e.stopPropagation();
                        onRemoveFromSession(user, session.id);
                      }}
                    />

                    <div
                      className={styles.FlippedCard}
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                    >
                      <div className={styles.hdbCard}>
                        <Avatar
                          alt={user.fullName}
                          src={user.profileImage || defaultProfileIcon}
                          sx={{
                            width: 50,
                            height: 50,
                            border: "2px solid #fff",
                            boxShadow: "0 0 8px rgba(0,0,0,0.1)",
                          }}
                        />
                        <div className={styles.hdbLabel}>
                          {user?.allocatedProgram?.name}
                        </div>
                      </div>
                      <div className={styles.swapAction}>
                        <div className={styles.swapText}>
                          {selectedSwapSeeker ? (
                            // Show both users' movements when swap seeker is selected
                            <>
                              Moving {user.fullName} to{" "}
                              {selectedSwapSeeker?.allocatedProgram?.name} and{" "}
                              {selectedSwapSeeker.fullName} to{" "}
                              {user?.allocatedProgram?.name}
                              <div>
                                <img src={swaparrow} alt="arrow" />
                              </div>
                            </>
                          ) : (
                            // Show single user movement when no swap seeker selected
                            <>
                              moving {user.fullName} from{" "}
                              {user?.allocatedProgram?.name} to {session?.name}
                              <div>
                                <img src={uniarrow} alt="arrow" />
                              </div>
                            </>
                          )}
                        </div>

                        <div className={styles.blessButton}>
                          <Button
                            buttonClassName={styles.confirmButton}
                            buttonTextClassName={styles.cancelText}
                            onClick={(e) => {
                              e.stopPropagation();

                              handleSessionGridBlessAction({
                                user,
                                session,
                                selectedSwapSeeker,
                                handleBlessed,
                                onBless,
                              });
                            }}
                          >
                            {session.name !== "Hold"
                              ? session.name !== "YTD"
                                ? "bless"
                                : "YTD"
                              : "Hold"}
                          </Button>
                        </div>
                      </div>

                      {selectedSwapSeeker ? (
                        <div className={styles.hdbCard}>
                          <Avatar
                            alt={selectedSwapSeeker.fullName}
                            src={
                              selectedSwapSeeker.profileImage ||
                              defaultProfileIcon
                            }
                            sx={{
                              width: 50,
                              height: 50,
                              border: "2px solid #fff",
                              boxShadow: "0 0 8px rgba(0,0,0,0.1)",
                            }}
                          />
                          <div className={styles.hdbLabel}>
                            {selectedSwapSeeker?.allocatedProgram?.name}
                          </div>
                        </div>
                      ) : (
                        <div
                          className={styles.hdbCard}
                          onClick={() => {
                            console.log("Opening session overlay", user);
                            handleOpenSessionOverlay(user.id, session);
                          }}
                        >
                          <div className={styles.avatarWithText}>
                            <span className={styles.selectSeekerText}>
                              select seeker to swap
                            </span>
                            <div
                              className={styles.roundImageBg}
                              style={{
                                backgroundImage: `url(${profile})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat",
                              }}
                            ></div>
                          </div>
                          <div className={styles.hdbLabel}>{session?.name}</div>
                        </div>
                      )}
                    </div>
                  </div>
                ),
              )
            ) : (
              <DashedBorderBox isDragOver={dragOverSessionId === session.id}>
                <div
                  className={`${styles.sessionHeader} ${dragOverSessionId === session.id ? styles.dragOver : ""}`}
                >
                  <h3 className={styles.sessionName}>{session.name}</h3>
                </div>
                <div className={styles.sessionInfo}>
                  <div className={styles.sessionCount}>
                    {session.name === "Hold" || session.name === "YTD" ? (
                      <span className={styles.totalSeekers}>
                        {session.totalSeekers}
                      </span>
                    ) : (
                      <p>
                        {session.allocatedCount} /{" "}
                        <span className={styles.totalSeekers}>
                          {session.totalSeekers}
                        </span>
                      </p>
                    )}
                  </div>
                  {session.name !== "Hold" && session.name !== "YTD" && (
                    <div className={styles.progressBarContainer}>
                      <div
                        className={styles.progressBar}
                        style={{
                          width:
                            session.totalSeekers > 0
                              ? `${(session.allocatedCount / session.totalSeekers) * 100}%`
                              : "0%",
                        }}
                      />
                    </div>
                  )}
                </div>
              </DashedBorderBox>
            )}
          </div>
        </div>
      ))}
      {/* {showOverlay && selectedSession && (
        <SessionOverlay
          session={selectedSession}
          isOpen={showOverlay}
          sessionId={sessionId}
          onClose={onCloseOverlay}
          users={approvedUsers}
          handleBless={onBless}
          loading={isLoading}
          programId={programId}
          totalRecords={totalRecords}
          sessiondata={sessions}
          fromSessionGrid={true}
          sessionpaginationProps={sessionpaginationProps}
          handleSessionPageChange={handleSessionPageChange}
          handleSessionPageSizeChange={handleSessionPageSizeChange}
          setSessionSearchText={setSessionSearchText}
          overlayLoader={overlayLoader}
          setSelectedFilter={setSelectedFilter}
          selectedFilter={selectedFilter}
          fetchApprovedUsersForSession={fetchApprovedUsersForSession}
        />
      )} */}
    </div>
  );
};
